import * as Yup from 'yup';
import { useEffect, useState, useContext } from 'react';
import { Link as RouterLink, useHistory} from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';

import {
  Stack,
  TextField,
  Typography,
  Backdrop,
  CircularProgress
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
//Notificacao
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//Autenticar
import Auth from "../../contexts/Auth";
import exportedRouters from '../../../constants/serverFunctions';
import axios from 'axios';



export default function RecuperarSenhaForm( ) {

  const { isAuthenticated, setIsAuthenticated } = useContext(Auth);

  const [Entidades, setEntidades] = useState();
  const [Perfil, setPerfil] = useState();
  const [msgRecuperacaoSenha, setMsgRecuperacaoSenha] = useState("");
  const [loading, setLoading] = useState(false);

  let history = useHistory();

  const LoginSchema = Yup.object().shape({
   emailUsuario: Yup.string().required('Campo obrigatório')
  });

  const formik = useFormik({
    initialValues: {
      emailUsuario: ''
    },
    validationSchema: LoginSchema,
    onSubmit: async (values, { setSubmitting }) => {
      const value = values.emailUsuario.trim();
      setLoading(true);
      setBlocked(true);
      try {
        const mensagem = await encaminharEmailRecuperacaoSenha(value);
        setTimeout(() => {
          history.push('/login');
        }, 6000);
      } catch (err) {
        console.error(err);
        setBlocked(false);
        setLoading(false);
      } finally {
        setSubmitting(false);
      }
    }
  });

  const encaminharEmailRecuperacaoSenha = async (email) => {
    try {
      const url = exportedRouters.senha.ENCAMINHAR_EMAIL_RECUPERACAO_SENHA;
      const response = await axios.post(url,{email:email});
      setLoading(false);
      const mensagem = response.data.message;
      setMsgRecuperacaoSenha(mensagem)
      return mensagem;
    } catch (error) {
      console.error("Erro ao encaminhar email de recuperação de senha:", error);
    }
  }

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, setFieldTouched } = formik;
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
     history.push({
           pathname: `/Instituicao`,
           state: { entidades: Entidades,nivelPerfil: Perfil  },
         });
    }
  }, [history, isAuthenticated,Entidades,Perfil]);

  const [cpfCnpj, setCpfCnpj] = useState("");
  
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        {!blocked ? (
         <>
          <Stack spacing={3}>
            <TextField
              fullWidth
              autoComplete="emailUsuario"
              type="text"
              label="CPF / CNPJ / E-mail"
              {...getFieldProps('emailUsuario')}
              error={Boolean(touched.emailUsuario && errors.emailUsuario)}
              helperText={touched.emailUsuario && errors.emailUsuario}
            />
          </Stack>

          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
          
          </Stack>
          <LoadingButton
              fullWidth
              className='btn-login'
              size="large"
              type="submit"
              variant="contained"
              loading={isSubmitting}
              disabled={isSubmitting}
            >
              Recuperar senha
            </LoadingButton>
            <Backdrop open={loading} style={{ zIndex: 1300 }}>
              <CircularProgress color="inherit" />
            </Backdrop>
         </>
        ) : (
          <>
            <Backdrop open={loading} style={{ zIndex: 1300 }}>
              <CircularProgress color="inherit" />
            </Backdrop>
            <Typography variant="h6" align="center" gutterBottom>
              {msgRecuperacaoSenha}
            </Typography>
            {msgRecuperacaoSenha && (
              <Typography variant="body2" align="center">
                Você será redirecionado para a página de login em alguns segundos.
              </Typography>
            )}
          </>
        )}
      </Form>

      <ToastContainer />
    </FormikProvider>
  );
}

